export const checkRoles = (...args) => {
  let roles = localStorage.roles || "[]";
  roles = JSON.parse(roles)
  if (!Array.isArray(roles)) {
    roles = [roles]
  }
  return args.some(role => {
    return roles.includes(role)
  })
}

export const isInRoles = (roles) => {
  if (roles == null) return false;
  const list = Array.isArray(roles) ? roles : [roles];
  return checkRoles(...list);
};